
export const data = [
    {
        id: 1,
        name: 'T-shirt',
        price: 200,
        category:"men",
        image : "https://m.media-amazon.com/images/I/A1R4INfMHyL._CLa%7C2140%2C2000%7C71u6pkoDzCL.png%7C0%2C0%2C2140%2C2000%2B0.0%2C0.0%2C2140.0%2C2000.0_AC_SX569_.png"
      },
      {
        id: 2,
        name: 'Pants',
        price: 200,
        category:"men",
        image : "https://cdn.britannica.com/74/190774-050-52CE5745/jeans-denim-pants-clothing.jpg"
      },
      {
        id: 3,
        name: 'Shoes',
        price: 400,
        category:"men",
        image : "https://media.gq.com/photos/63eba1b2275d2fef78a425c2/master/pass/nike-running-shoes-streakfly-invincible.jpg"
      },
      {
        id: 4,
        name: 'Hats',
        price: 250,
        category:"men",
        image: "https://img.freepik.com/free-vector/hats-caps-men-women-cartoon-illustrations-set-retro-modern-male-female-headgear-cowboy-summer-straw-hat-isolated-white_74855-20611.jpg"
      },
      {
        id: 5,
        name: 'Socks',
        price: 100,
        category:"women",
        image : "https://assets.ajio.com/medias/sys_master/root/20230818/5o7M/64df5974ddf77915194f627b/-1117Wx1400H-463597540-multi-MODEL.jpg"
      },
      {
      id: 6,
      name: 'Dress',
      price: 600,
      category:"women",
      image: 'https://st.depositphotos.com/2515135/2791/v/450/depositphotos_27912009-stock-illustration-woman-beautiful-dresses-on-hanger.jpg'
      },
      {
      id: 7,
      name: 'Jacket',
      price: 700,
      category:"men",
      image: 'https://img.freepik.com/free-photo/still-life-rendering-jackets-display_23-2149745029.jpg?size=626&ext=jpg&ga=GA1.1.1700460183.1708300800&semt=ais'
    },
    {
      id: 8,
      name: 'Skirt',
      price: 800,
      category:"women",
      image: 'https://lzd-img-global.slatic.net/g/p/10783bba734556ae40f3596e0dcc9728.png_720x720q80.png'
    },
    {
      id: 9,
      name: 'Sunglasses',
      price: 900,
      category:"men",
      image: 'https://spectacular-blog.lenskart.com/wp-content/uploads/march2021/Sunglass-Lenses_OI.jpg'
    },
    {
      id: 10,
      name: 'Watch',
      price: 1000,
      category:"men",
      image: 'https://images.pexels.com/photos/190819/pexels-photo-190819.jpeg?cs=srgb&dl=pexels-fernando-arcos-190819.jpg&fm=jpg'
    },
    {
    id: 11,
    name: 'Backpack',
    price: 1200,
    category:"men",
    image: 'https://assets.teenvogue.com/photos/649db3fba3adae73f01cffa6/16:9/w_5280,h_2970,c_limit/GettyImages-1482842893.jpg'
    },
    {
    id: 12,
    name: 'Sweater',
    price: 1500,
    image: 'https://img.freepik.com/premium-photo/warm-fashionable-embrace-winter-with-wool-sweaters_984027-9590.jpg'
    },
    {
    id: 13,
    name: 'Sneakers',
    price: 1800,
    category:"men",
    image: 'https://images.wave.fr/images//nike-jordan-converse-all-star-week-end-infos-1000x750.jpg'
    },
    {
    id: 14,
    name: 'Necklace',
    price: 2000,
    category:"jewellery",
    image: 'https://media.karousell.com/media/photos/products/2020/5/16/vintage_brass_heart_ornate_nec_1589650528_0071ed92_progressive.jpg'
    },
    {
    id: 15,
    name: 'Gloves',
    price: 500,
    category:"men",
    image: 'https://powersports.in/cdn/shop/products/KORDA_Track_Gloves_1.jpg?v=1662531545'
    },
    {
      id: 16,
      name: 'Earrings',
      price: 300,
      category: "jewellery",
      image: "https://outhouse-jewellery.com/cdn/shop/products/majesty-earrings.jpg?v=1676450083"
    },
    {
      id: 17,
      name: 'Smartwatch',
      price: 600,
      category: "electronics",
      image: "https://cdn.lovcour.com/wp-content/uploads/2022/09/11015445/46mm-360-hd-full-touch-screen-men-smart-watch-24-680x850.jpg"
    },
    {
      id: 18,
      name: 'Headphones',
      price: 150,
      category: "electronics",
      image: "https://cdn.thewirecutter.com/wp-content/media/2023/07/bluetoothheadphones-2048px-0876.jpg?auto=webp&quality=75&width=1024"
    },
    {
      id: 19,
      name: 'Laptop',
      price: 1200,
      category: 'electronics',
      image: 'https://www.cnet.com/a/img/resize/01ebf2fb7a844ce940f0b1c3ddc148faddc4a6c1/hub/2022/04/27/b796792b-5b34-4405-83eb-efc66371ee06/samsung-galaxy-book-2-pro-360-01.jpg?auto=webp&fit=crop&height=900&width=1200'
    },
    {
      id: 20,
      name: 'Smartphone',
      price: 800,
      category: 'electronics',
      image: 'https://www.zdnet.com/a/img/resize/06119597d8fde27e3074dc3bb4a9ce0f1851280a/2023/04/24/4e586f53-afa2-452d-baf4-cc7c78c2c5fb/samsung-galaxy-a54-5g.jpg?auto=webp&fit=crop&height=900&width=1200'
    },
    {
      id: 21,
      name: 'Ring',
      price: 1200,
      category: "jewellery",
      image: "https://assets.ajio.com/medias/sys_master/root/20211222/P7M5/61c22029f997ddf8f15a624e/-1117Wx1400H-469083546-whitegold-MODEL.jpg"
    },
    {
      id: 22,
      name: 'Digital Camera',
      price: 800,
      category: "electronics",
      image: "https://carlos.gi/cdn/shop/products/NikonCOOLPIXP1000DigitalCamera_580x.jpg?v=1632325957"
    },
    {
      id: 23,
      name: 'Fitness Tracker',
      price: 150,
      category: "electronics",
      image: "https://www.getgear.in/cdn/shop/files/01_charge6-obsidian-device-3qt_1024x1024.png?v=1695206227"
    },
    {
      id: 24,
      name: 'Leather Jacket',
      price: 1200,
      category: "men",
      image: "https://i.ebayimg.com/thumbs/images/g/PpEAAOSwO25jeazD/s-l640.jpg"
    },
    {
      id: 25,
      name: 'Formal Shirt',
      price: 600,
      category: "men",
      image: "https://www.zodiaconline.com/media/catalog/product/cache/253fb0759a515d30bcbc159f082108b5/z/o/zodiac_shirts_barboni3_cf_z1_100_cotton_stripe_036_fssc_bd_blue_10_01.jpg"
    },
    {
      id: 26,
      name: 'Dress Shoes',
      price: 1000,
      category: "women",
      image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRegUfJv9KYyq0uoQpD8hzhvG--rA62OyXc1g&usqp=CAU"
    },
    {
      id: 27,
      name: 'Handbag',
      price: 1500,
      category: "women",
      image: "https://m.media-amazon.com/images/I/61GpT8+nFXL._AC_UY1000_.jpg"
    },
    {
      id: 28,
      name: 'Bracelet',
      price: 300,
      category: "jewellery",
      image: "https://kinclimg8.bluestone.com/f_jpg,c_scale,w_1024,q_80,b_rgb:f0f0f0/giproduct/BIPO0671V01-POSTER-50047.jpg"
    },

];